import { useIntl } from "react-intl";

const SLAManagement = () => {
    const intl = useIntl();
    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.SLAManagement.header",
            defaultMessage: "SLA (service-level agreement) management"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.SLAManagement.body",
            defaultMessage:
                "Meet your SLAs so agents get the important work done first. Configure and get going in minutes."
        })
    };
    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
        </>
    );
};

export default SLAManagement;
